<template>
 <admin-header></admin-header>
 <admin-sidebar></admin-sidebar>
  <div class="page-wrapper cardhead">
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Bootstrap Icon</h3>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <div class="row">
        <!-- Icon -->
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Bootstrap Icons</div>
            </div>
            <div class="card-body">
              <p class="mb-2">
                <code>&lt;i class="bi bi-ICON_NAME"&gt;&lt;/i&gt;</code>. For more
                information
                <a
                  href="https://icons.getbootstrap.com/"
                  target="_blank"
                  class="text-primary"
                  >click here</a
                >.
              </p>
              <div class="icons-items">
                <div class="icons-list">
                  <div class="icons-list-item">
                    <i
                      class="bi bi-house"
                      data-bs-toggle="tooltip"
                      title="bi bi-house"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-speedometer2"
                      data-bs-toggle="tooltip"
                      title="bi bi-speedometer2"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i class="bi bi-map" data-bs-toggle="tooltip" title="bi bi-map"></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-chat-left-text"
                      data-bs-toggle="tooltip"
                      title="bi bi-chat-left-text"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-people"
                      data-bs-toggle="tooltip"
                      title="bi bi-people"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-card-image"
                      data-bs-toggle="tooltip"
                      title="bi bi-card-image"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-file-earmark-text"
                      data-bs-toggle="tooltip"
                      title="bi bi-file-earmark-text"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-bar-chart"
                      data-bs-toggle="tooltip"
                      title="bi bi-bar-chart"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-arrow-clockwise"
                      data-bs-toggle="tooltip"
                      title="bi bi-arrow-clockwise"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i class="bi bi-list" data-bs-toggle="tooltip" title="bi bi-list"></i>
                  </div>

                  <div class="icons-list-item">
                    <i class="bi bi-gear" data-bs-toggle="tooltip" title="bi bi-gear"></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-building"
                      data-bs-toggle="tooltip"
                      title="bi bi-building"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-basket"
                      data-bs-toggle="tooltip"
                      title="bi bi-basket"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-camera-reels"
                      data-bs-toggle="tooltip"
                      title="bi bi-camera-reels"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i class="bi bi-bell" data-bs-toggle="tooltip" title="bi bi-bell"></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-envelope"
                      data-bs-toggle="tooltip"
                      title="bi bi-envelope"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-pin-angle"
                      data-bs-toggle="tooltip"
                      title="bi bi-pin-angle"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-pie-chart"
                      data-bs-toggle="tooltip"
                      title="bi bi-pie-chart"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-check2-square"
                      data-bs-toggle="tooltip"
                      title="bi bi-check2-square"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-check2-all"
                      data-bs-toggle="tooltip"
                      title="bi bi-check2-all"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-archive"
                      data-bs-toggle="tooltip"
                      title="bi bi-archive"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-arrow-down-square"
                      data-bs-toggle="tooltip"
                      title="bi bi-arrow-down-square"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-arrow-down-up"
                      data-bs-toggle="tooltip"
                      title="bi bi-arrow-down-up"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-cloud-arrow-down"
                      data-bs-toggle="tooltip"
                      title="bi bi-cloud-arrow-down"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-database"
                      data-bs-toggle="tooltip"
                      title="bi bi-database"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-laptop"
                      data-bs-toggle="tooltip"
                      title="bi bi-laptop"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-exclamation-circle"
                      data-bs-toggle="tooltip"
                      title="bi bi-exclamation-circle"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-three-dots-vertical"
                      data-bs-toggle="tooltip"
                      title="bi bi-three-dots-vertical"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-download"
                      data-bs-toggle="tooltip"
                      title="bi bi-download"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-trash3"
                      data-bs-toggle="tooltip"
                      title="bi bi-trash3"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-folder2-open"
                      data-bs-toggle="tooltip"
                      title="bi bi-folder2-open"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-calendar"
                      data-bs-toggle="tooltip"
                      title="bi bi-calendar"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i class="bi bi-star" data-bs-toggle="tooltip" title="bi bi-star"></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-clock"
                      data-bs-toggle="tooltip"
                      title="bi bi-clock"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-telephone"
                      data-bs-toggle="tooltip"
                      title="bi bi-telephone"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="bi bi-camera-video"
                      data-bs-toggle="tooltip"
                      title="bi bi-camera-video"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Icon -->
      </div>
    </div>
  </div>
</template>
